import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const About = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-brand-green to-brand-green-dark text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Sobre Nós
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-12">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                Quem Somos
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                A Deslumbrângulo desenvolve sistemas de gestão técnica para edifícios, 
                instalações e infraestruturas. Trabalhamos com entidades públicas e privadas 
                na implementação de soluções de monitorização, controlo e otimização.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                As nossas soluções combinam tecnologia e conhecimento técnico para responder 
                às necessidades específicas de cada projeto.
              </p>
            </div>

            <div className="border-t border-gray-200 pt-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                Abordagem
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                Desenvolvemos soluções adaptadas a cada contexto, priorizando a integração 
                com sistemas existentes e a flexibilidade para ajustes futuros. O nosso 
                trabalho baseia-se na análise técnica, implementação cuidada e 
                acompanhamento contínuo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Quer Saber Mais?
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Entre em contacto para discutirmos o seu projeto.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white px-10 transition-all duration-300 hover:scale-105">
                Pedir Contacto
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
